import {
    READINGS_DEVICES_REQUEST,
    READINGS_DEVICES_SUCCESS,
    READINGS_DEVICES_FAILURE,
    READINGS_DATA_REQUEST,
    READINGS_DATA_SUCCESS,
    READINGS_DATA_FAILURE,
    READINGS_FILTER_APPLY,
    READINGS_RESET
} from "./ActionTypes";

const createInitialState = () => ({
    devices: {
        items: [],
        loading: false,
        error: null,
        requestId: null,
        objectId: null
    },

    chart: {
        items: [],
        loading: false,
        error: null,
        failedDeviceIds: [],
        requestId: null
    },

    appliedFilter: {
        dateFrom: null,
        dateTo: null,
        groupBy: "day",
        selectedDeviceIds: []
    },

    hasAppliedFilter: false
});

const initialState = createInitialState();

const ReadingsReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case READINGS_DEVICES_REQUEST:
            return {
                ...state,

                devices: {
                    items: [],
                    loading: true,
                    error: null,
                    requestId: action.requestId,
                    objectId: action.objectId
                }
            };

        case READINGS_DEVICES_SUCCESS:
            // Не принимаем результат устаревшего запроса.
            if (
                state.devices.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                devices: {
                    items: action.items || [],
                    loading: false,
                    error: null,
                    requestId: action.requestId,
                    objectId: state.devices.objectId
                }
            };

        case READINGS_DEVICES_FAILURE:
            // Ошибка могла прийти от уже устаревшего запроса.
            if (
                state.devices.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                devices: {
                    items: [],
                    loading: false,

                    error:
                        action.error ||
                        "Не удалось загрузить устройства",

                    requestId: action.requestId,
                    objectId: state.devices.objectId
                }
            };

        case READINGS_FILTER_APPLY:
            return {
                ...state,

                appliedFilter: {
                    ...state.appliedFilter,
                    ...action.filter,

                    selectedDeviceIds:
                        action.filter &&
                        action.filter.selectedDeviceIds
                            ? [
                                ...action.filter
                                    .selectedDeviceIds
                            ]
                            : []
                },

                hasAppliedFilter: true
            };

        case READINGS_DATA_REQUEST:
            return {
                ...state,

                chart: {
                    items: [],
                    loading: true,
                    error: null,
                    failedDeviceIds: [],
                    requestId: action.requestId
                }
            };

        case READINGS_DATA_SUCCESS:
            // Пользователь мог применить новый фильтр,
            // пока предыдущий запрос ещё выполнялся.
            if (
                state.chart.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                chart: {
                    items: action.items || [],
                    loading: false,
                    error: null,
                    failedDeviceIds:
                        action.failedDeviceIds || [],
                    requestId: action.requestId
                }
            };

        case READINGS_DATA_FAILURE:
            if (
                state.chart.requestId !==
                action.requestId
            ) {
                return state;
            }

            return {
                ...state,

                chart: {
                    items: [],
                    loading: false,

                    error:
                        action.error ||
                        "Не удалось загрузить показания",

                    failedDeviceIds:
                        action.failedDeviceIds || [],

                    requestId: action.requestId
                }
            };

        case READINGS_RESET:
            return createInitialState();

        default:
            return state;
    }
};

export default ReadingsReducer;